export default "__VITE_ASSET__D416K85h__"